import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const items = [{
  emoji: '🎓',
  text: 'Acceso completo a los 8 módulos'
}, {
  emoji: '📱',
  text: 'Acceso desde celular, tablet o PC'
}, {
  emoji: '⏳',
  text: 'Acceso de por vida + actualizaciones'
}, {
  emoji: '📄',
  text: 'Guías descargables en PDF'
}, {
  emoji: '🎁',
  text: 'Bonus: Lista de proveedores'
}, {
  emoji: '🎁',
  text: 'Bonus: Plantilla de presupuesto'
}, {
  emoji: '📜',
  text: 'Certificado de finalización'
}];
export function Incluye() {
  return <section className="w-full bg-[#f6f1fb] py-24" data-id="element-71" data-mp="2rlxv2h6nhmk8">
      <div className="mx-auto max-w-4xl px-6" data-id="element-72" data-mp="2vp46s4cj85y3">
        <Reveal data-id="element-73" data-mp="2vn9lgoxcmbth">
          <h2 className="font-display text-center text-3xl font-semibold text-[#2f2a33] sm:text-4xl" data-id="element-74" data-mp="30ogt8nzhrb05">
            Todo lo que recibís cuando te inscribís hoy
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-4 sm:grid-cols-2" data-id="element-75" data-mp="11dpg9lbp62ha">
          {items.map((it, i) => <Reveal key={i} delay={i % 2 * 0.05} data-id="element-76" data-mp="16cil6pcx4l5u" data-mpi={i}>
              <div className="flex items-center justify-between gap-4 rounded-2xl bg-white p-5 shadow-sm ring-1 ring-black/5" data-id="element-77" data-mp="2ga1ifczazh1m">
                <div className="flex items-center gap-3" data-id="element-78" data-mp="2bh00ew3sv1dt">
                  <span className="text-2xl" data-id="element-79" data-mp="27fwkyapnz7d4">{it.emoji}</span>
                  <p className="font-medium text-[#2f2a33]" data-id="element-80" data-mp="27ebpmivizke7">{it.text}</p>
                </div>
                <span className="flex shrink-0 items-center gap-1 rounded-full bg-[#ec4899]/10 px-3 py-1 text-sm font-semibold text-[#db2777]" data-id="element-81" data-mp="22fie2vzsu3go">
                  <CheckIcon className="h-4 w-4" data-id="element-82" data-mp="2v60pqlel9d5p" />
                  Incluido
                </span>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}